import axios from 'axios'
import { setupCache } from 'axios-cache-adapter'

const cache = setupCache({
  maxAge: 60 * 1000,
  exclude: { query: false }
})

const httpGet = axios.create({
  adapter: cache.adapter
})


export function headerData() {
  const url = 'https://www.katsomo.fi/multimedia/verkosto/partner.json'

  return httpGet(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then((result) => {
    return {
      title: result.data.header.title,
      text: result.data.header.subtitle,
      images: result.data.header.image,
      notifications: result.data.notifications,
    }
  }, (error) => {
    return {
      title: 'Tervetuloa MTV Katsomon partnerisivuille',
      text: '',
      images: []
    }
  })
}
